var map = {
	"./adidas.svg": 70,
	"./amazon.svg": 71,
	"./asos.svg": 72,
	"./booking.svg": 73,
	"./deliveroo.svg": 74,
	"./docusign.svg": 75,
	"./instacart.svg": 76,
	"./intercom.svg": 77,
	"./lya.svg": 78,
	"./peloton.svg": 79,
	"./postmates.svg": 80,
	"./salesforce.svg": 81,
	"./shopify.svg": 82,
	"./ticketmaster.svg": 83,
	"./unicef.svg": 84
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;